import React from "react";
import "./ListItem.scss";

interface ListItemProps {
    resultData: { title: string };
    isDisabled: boolean;
    onClick?: (query: string) => void;
}

export const ListItem: React.FC<ListItemProps> = ({ resultData, onClick, isDisabled }) => {
    const { title } = resultData;

    if (!title) {
        return null;
    }

    return (
        <li className="new-ai-result-list">
            <a
                href={`javascript:void(0)`}
                target={"_self"}
                className={`new-ai-result-link ${isDisabled ? 'new-ai-result-link--disabled' : ''}`}
                rel="noreferrer"
                onClick={() => !isDisabled && onClick && onClick(title)}
            >
                <div
                    className="sui-result__details"
                    dangerouslySetInnerHTML={{
                        __html: title,
                    }}
                ></div>
            </a>
        </li>
    );
};
